import React from "react";
import NTMButton from "./Buttons";

export default function TabSelector({selected, id, label, setTab}) {
	return <NTMButton
		secondary={selected === id}
		primary={selected !== id}
		onClick={() => setTab(id)}>{label}</NTMButton>;
}
